import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(public auth: AuthService) { }

  ngOnInit() {
  }

  loginWithGoogle() {
    this.auth.login().subscribe(res => {
      console.log(res);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts